export function chooseNiceTimeMask(date, intervalMap) {
  var second = intervalMap.second,
    minute = intervalMap.minute,
    hour = intervalMap.hour,
    day = intervalMap.day,
    week = intervalMap.week,
    month = intervalMap.month,
    year = intervalMap.year;
  if (second.floor(date) < date) return '.SSS';
  if (minute.floor(date) < date) return ':ss';
  if (hour.floor(date) < date) return 'hh:mm';
  if (day.floor(date) < date) return 'hh A';
  if (month.floor(date) < date) {
    if (week.floor(date) < date) return 'MMM DD';
    return 'ddd DD';
  }
  if (year.floor(date) < date) return 'MMMM';
  return 'YYYY';
}